<template>
  <div class="ren-decoration-cp ren-decoration-cp-action-card">
    <i :style="avatarStyle">{{ avatarText }}</i>
    <div>
      <strong>{{ brandName }}</strong>
      <span v-if="slogan">{{ slogan }}</span>
    </div>
    <button type="button" :style="linkStyle">{{ signLabel }}</button>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { stringValue } from '../../../previews/preview-helpers'
import type { WidgetPreviewProps } from '../../types'

const props = defineProps<WidgetPreviewProps>()

const brandName = computed(() => stringValue(props.component.props?.brandName, '准准'))
const slogan = computed(() =>
  stringValue(props.component.props?.slogan || props.component.props?.subtitle)
)
const avatarText = computed(() => {
  const value = stringValue(props.component.props?.avatarText).trim()
  return value || brandName.value.slice(0, 1)
})
const signLabel = computed(() => stringValue(props.component.props?.signLabel, '日签'))
const avatarStyle = computed(() => ({
  backgroundColor:
    stringValue(props.component.style?.accentColor) ||
    props.themeTokens?.primaryColor ||
    props.themeColor ||
    'var(--ren-theme-primary)'
}))
const linkStyle = computed(() => ({
  color: props.themeTokens?.primaryColor || props.themeColor || 'var(--ren-theme-primary)',
  backgroundColor: 'transparent'
}))
</script>
